var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhitePlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-0.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7543",
    "data-name": "Rectangle 7543",
    width: 31,
    height: 31,
    transform: "translate(0.477)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7544",
    "data-name": "Rectangle 7544",
    width: 31,
    height: 31,
    transform: "translate(0.477)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7545",
    "data-name": "Rectangle 7545",
    width: 31,
    height: 31,
    transform: "translate(0.477)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(1.32 1.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26495",
    "data-name": "Group 26495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142407",
    "data-name": "Path 142407",
    d: "M16.2,2A14.139,14.139,0,1,0,26.266,6.141,14.2,14.2,0,0,0,16.2,2Zm0,25.824A11.621,11.621,0,1,1,27.824,16.2,11.621,11.621,0,0,1,16.2,27.824Z",
    transform: "translate(-2 -2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142408",
    "data-name": "Path 142408",
    d: "M26.2,18.456H21.038V13.291a1.291,1.291,0,1,0-2.582,0v5.165H13.291a1.291,1.291,0,1,0,0,2.582h5.165V26.2a1.291,1.291,0,0,0,2.582,0V21.038H26.2a1.291,1.291,0,0,0,0-2.582Z",
    transform: "translate(-5.544 -5.544)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePlus);
export default __webpack_public_path__ + "static/media/white_plus.1978f468f4b97f37a71c60ea55697963.svg";
export { ForwardRef as ReactComponent };